import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ModalDrawService } from '../modal-draw.service';
import { Subscription, tap } from 'rxjs';
import { VisorgisService } from '../../../services/visorgis.service';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-draw-hidrante',
  templateUrl: './draw-hidrante.component.html',
  styleUrls: ['./draw-hidrante.component.css'],
  imports: [IonicModule, FormsModule, ReactiveFormsModule],
})
export class DrawHidranteComponent implements OnInit, OnDestroy {
  @Input() att: any;
  formSubscription: Subscription[] = [];
  @Output() onSubmitComplete: EventEmitter<any> = new EventEmitter<any>();

  myForm = this.fb.group({
    name: ['', Validators.required],
  });

  constructor(
    private fb: FormBuilder,
    private modalService: ModalDrawService,
    private visorgisServ: VisorgisService
  ) {}

  ngOnInit(): void {
    if (this.att) {
      console.log(this.att);
      this.myForm.patchValue({
        name: this.att.name,
      });
    }
    this.formSubscription.push(
      this.myForm.statusChanges
        .pipe(
          tap(res => {
            this.modalService.formularioValido(res == 'VALID');
          })
        )
        .subscribe()
    );
    this.formSubscription.push(
      this.modalService.confirmButton
        .pipe(
          tap(res => {
            this.onSubmit(res);
          })
        )
        .subscribe()
    );
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.formSubscription.forEach(s => s.unsubscribe());
  }

  onSubmit(geojson) {
    if (this.att) {
      this.att.name = this.myForm.controls['name'].value;
      this.visorgisServ
        .editHidranteById(this.att)
        .pipe(
          tap(res => {
            console.log(res);
            this.onSubmitComplete.emit(res);
          })
        )
        .subscribe();
    } else {
      geojson.properties.name = this.myForm.controls['name'].value;
      this.visorgisServ
        .createHidrante(geojson)
        .pipe(
          tap(res => {
            console.log(res);
            this.onSubmitComplete.emit(res);
          })
        )
        .subscribe();
    }
  }
}
